import { render, staticRenderFns } from "./AgenciaPaxsItem.vue?vue&type=template&id=4eddfd1e"
import script from "./AgenciaPaxsItem.vue?vue&type=script&lang=js"
export * from "./AgenciaPaxsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports